import { render } from "./ExamSession.vue?vue&type=template&id=619c8c88&scoped=true"
import script from "./ExamSession.vue?vue&type=script&lang=js"
export * from "./ExamSession.vue?vue&type=script&lang=js"

import "./ExamSession.vue?vue&type=style&index=0&id=619c8c88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619c8c88"]])

export default __exports__